"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = exports.sleep = void 0;
var sleep_1 = require("./sleep");
Object.defineProperty(exports, "sleep", { enumerable: true, get: function () { return sleep_1.sleep; } });
var identifiers_1 = require("./identifiers");
Object.defineProperty(exports, "uuid", { enumerable: true, get: function () { return identifiers_1.uuid; } });
